// extracted by mini-css-extract-plugin
module.exports = {"model-header":"style_model-header__1rysl","icon":"style_icon__17hR0","header-content":"style_header-content__1n7qW","title":"style_title__1aBiT"};